import { Box } from "@mantine/core";
import { MainLayout } from "../../layouts/MainLayout";
import { Calendar } from "../../widgets/development-plan/Calendar";
import { useMediaQuery } from "@mantine/hooks";

export const DevelopmentPlan = () => {
  const mobile = useMediaQuery("(max-width: 650px)");
  return (
    <MainLayout>
      <Box m={mobile ? "24px 16px " : 40}>
        <Calendar />
      </Box>
    </MainLayout>
  );
};
